export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Vest_Normal.c6646288.tga";